(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.size = 4;
        this.board = this.initialState.map(function(row) {
            return row.slice();
        });
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i].filter(function(item) {
                        return item !== 0;
                    });
                    for(var j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                        row[j] *= 2;
                        row[j + 1] = 0;
                        _this.score += row[j];
                    }
                    row = row.filter(function(item) {
                        return item !== 0;
                    });
                    while(row.length < _this.size)row.push(0);
                    if (_this.board[i].join("") !== row.join("")) moved = true;
                    _this.board[i] = row;
                };
                var moved = false;
                if (this.status !== "playing") return;
                for(var i = 0; i < this.size; i++)_loop(i);
                if (moved) this.postMoved();
            }
        },
        {
            key: "reverseRows",
            value: function reverseRows() {
                this.board.forEach(function(row) {
                    return row.reverse();
                });
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.reverseRows();
                this.moveLeft();
                this.reverseRows();
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var _this = this;
                this.board = this.board[0].map(function(_, index) {
                    return _this.board.map(function(row) {
                        return row[index];
                    });
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.transpose();
                this.moveLeft();
                this.transpose();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.transpose();
                this.moveRight();
                this.transpose();
            }
        },
        {
            key: "addRandom",
            value: function addRandom() {
                var emptyCells = [];
                for(var i = 0; i < this.size; i++){
                    for(var j = 0; j < this.size; j++)if (this.board[i][j] === 0) emptyCells.push({
                        x: i,
                        y: j
                    });
                }
                if (emptyCells.length === 0) return null;
                var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], x = _emptyCells_Math_floor.x, y = _emptyCells_Math_floor.y;
                this.board[x][y] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "postMoved",
            value: function postMoved() {
                this.addRandom();
                if (this.checkWin()) this.status = "win";
                if (this.checkLose()) this.status = "lose";
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                return this.board.some(function(row) {
                    return row.includes(2048);
                });
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var i = 0; i < this.size; i++)for(var j = 0; j < this.size; j++){
                    if (this.board[i][j] === 0) return false;
                    if (i > 0 && this.board[i][j] === this.board[i - 1][j]) return false;
                    if (j > 0 && this.board[i][j] === this.board[i][j - 1]) return false;
                    if (i < this.size - 1 && this.board[i][j] === this.board[i + 1][j]) return false;
                    if (j < this.size - 1 && this.board[i][j] === this.board[i][j + 1]) return false;
                }
                return true;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = this.initialState.map(function(rows) {
                    return rows.slice();
                });
                this.status = "playing";
                this.score = 0;
                this.addRandom();
                this.addRandom();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = this.initialState.map(function(rows) {
                    return rows.slice();
                });
                this.status = "idle";
                this.score = 0;
            }
        }
    ]);
    return Game;
}();
// export default Game;
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


// // import Game from '../modules/Game.class';
var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startGame = document.querySelector(".button.start");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
function $197cd56b15c33885$var$updateBoard() {
    var board = $197cd56b15c33885$var$game.getState();
    var rows = $197cd56b15c33885$var$gameField.querySelectorAll(".field-row");
    board.forEach(function(row, i) {
        var cells = rows[i].querySelectorAll(".field-cell");
        row.forEach(function(value, j) {
            cells[j].textContent = value === 0 ? "" : value;
            cells[j].className = "field-cell field-cell--".concat(value);
        });
        $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    });
}
function $197cd56b15c33885$var$updateMessage() {
    var statusGame = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    if (statusGame === "idle") $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    if (statusGame === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    if (statusGame === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    if (statusGame === "playing") {
        $197cd56b15c33885$var$startGame.classList.remove("start");
        $197cd56b15c33885$var$startGame.classList.add("restart");
        $197cd56b15c33885$var$startGame.textContent = "Restart";
    }
}
document.addEventListener("keydown", $197cd56b15c33885$var$handlePressKey);
function $197cd56b15c33885$var$handlePressKey(pressKey) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(pressKey.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateMessage();
}
$197cd56b15c33885$var$startGame.addEventListener("click", function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateMessage();
});
$197cd56b15c33885$var$updateBoard();
$197cd56b15c33885$var$updateMessage();

})();
//# sourceMappingURL=index.a20d05e0.js.map
